import { RouteNames } from "enums";

export const availablePacksUrl = `/${RouteNames.availablePacks}`;
